/** 智能引导步骤与选项（PRD：设备、通道、目标、模型） */

export type StepId = 'device' | 'channel' | 'goal' | 'model'

export interface WizardStep {
  id: StepId
  title: string
  question: string
  options: { value: string; label: string }[]
}

export const WIZARD_STEPS: WizardStep[] = [
  {
    id: 'device',
    title: '设备与算力',
    question: '你打算在什么环境下运行 OpenClaw？',
    options: [
      { value: 'pc-mac', label: '个人电脑（Mac）' },
      { value: 'pc-windows', label: '个人电脑（Windows）' },
      { value: 'vps', label: '云服务器 (VPS)' },
      { value: 'hosted', label: '无服务器（寻求托管 / 一键镜像）' },
    ],
  },
  {
    id: 'channel',
    title: '交互通道',
    question: '你希望通过什么方式与 AI 对话？',
    options: [
      { value: 'telegram', label: 'Telegram' },
      { value: 'whatsapp', label: 'WhatsApp' },
      { value: 'feishu', label: '飞书 (Feishu)' },
      { value: 'discord', label: 'Discord' },
      { value: 'slack', label: 'Slack' },
      { value: 'tui', label: '终端 TUI' },
    ],
  },
  {
    id: 'goal',
    title: '核心使用目标',
    question: '你主要想用 OpenClaw 做什么？',
    options: [
      { value: 'office', label: '日常办公' },
      { value: 'dev', label: '代码开发' },
      { value: 'scrape', label: '数据抓取' },
      { value: 'smart-home', label: '智能家居' },
      { value: 'kb', label: '知识库问答 / 私人大脑' },
    ],
  },
  {
    id: 'model',
    title: '模型偏好',
    question: '你倾向使用哪类模型？',
    options: [
      { value: 'local', label: '本地免费模型 (Ollama / LM Studio)' },
      { value: 'cloud', label: '云端强力模型 (Claude / OpenAI / DeepSeek / Kimi)' },
    ],
  },
]
